// Light/dark theme management: respects system preference by default and
// remembers each user's explicit choice in localStorage ('mfk_theme').
const KEY = 'mfk_theme';

export const getTheme = () => {
  const stored = localStorage.getItem(KEY);
  if (stored === 'dark' || stored === 'light') return stored;
  return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
};

export const applyTheme = (theme) => {
  document.documentElement.classList.toggle('dark', theme === 'dark');
};

// Call once at app boot (before first paint) to avoid a light-mode flash.
export const initTheme = () => {
  applyTheme(getTheme());
  // Follow system changes only while the user has not made an explicit choice.
  if (window.matchMedia) {
    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', (e) => {
      if (!localStorage.getItem(KEY)) applyTheme(e.matches ? 'dark' : 'light');
    });
  }
};

export const toggleTheme = () => {
  const next = getTheme() === 'dark' ? 'light' : 'dark';
  localStorage.setItem(KEY, next);
  applyTheme(next);
  return next;
};
